import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import ModalHeader from '../../../UniformComponents/ModalHeader'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'
import Tabs from './Tabs'
import Accordion from '../../ReportV2/components/Accordion'
import Select from '../../form/Select'
import Spinner from '../../../UniformComponents/Spinner'
import ChartPreview from './ChartPreview'
import Input from '../../form/Input'

@observer
class QuadrantSettings extends PureComponent {
    axisSettings = {
        xAxis: { label: 'X-Axis' },
        yAxis: { label: 'Y-Axis' },
        zAxis: { label: 'Z-Axis' },
    }

    constructor(props) {
        super(props)
        this.state = {
            error: {
                xAxis: false,
                yAxis: false,
            },
            previewChart: false,
        }
    }

    renderAccordion = (axis) => {
        const { error } = this.state
        const { dashboardWizardStore } = this.props
        const {
            newWidget, getQuadrantQuestions,
        } = dashboardWizardStore

        return (
            <div className="accordian" style={{ marginBottom: '15px' }}>
                <Accordion
                    cssClass="chartAccordian"
                    title={(
                        <div className="title">
                            {`${this.axisSettings[axis].label} question`}
                            <i
                                className="fa-regular fa-circle-exclamation"
                                style={
                                    {
                                        color: 'red',
                                        background: 'none',
                                        marginLeft: '20px',
                                        display: R.pathOr(false, [axis], error) ? 'block' : 'none',
                                    }
                                }
                            />
                        </div>
                    )}
                    openIcon="fa-regular fa-chevron-up"
                    closeIcon="fa-regular fa-chevron-down"
                >
                    <div className="questions" style={{ marginTop: '20px' }}>
                        <Select
                            label="Select Question"
                            classNamePrefix="relative"
                            onBlur={(value) => this.updateQuestions(value, axis)}
                            options={getQuadrantQuestions(false)}
                            isOptionSelected={(option, selectValue) => (
                                option.value === R.pathOr(undefined, [0, 'value'], selectValue)
                                && R.pathOr(undefined, [0, 'group'], selectValue) === option.group
                            )}
                            defaultValue={R.pathOr([], ['quadrant', axis], newWidget)}
                            indentation
                            showSelected
                        />
                    </div>
                </Accordion>
            </div>
        )
    }

    updateQuestions = (value, axis) => {
        const { dashboardWizardStore } = this.props
        const { changeNewWidget, newWidget } = dashboardWizardStore
        const currentValue = newWidget.quadrant || {}
        const newValue = { ...currentValue, [axis]: value }
        this.setState((prevState) => ({ error: { ...prevState.error, [axis]: false } }))
        changeNewWidget(newValue, 'quadrant')
    }

    addWidget = () => {
        const { dashboardWizardStore } = this.props
        const { newWidget, addWidget } = dashboardWizardStore
        const { error } = this.state
        const errorClone = R.clone(error)
        let isValid = true
        if (!newWidget.quadrant) {
            isValid = false
            errorClone.xAxis = true
            errorClone.yAxis = true
            this.setState({ error: errorClone })
            return
        }
        Object.keys(errorClone).forEach((k) => {
            if (k === 'zAxis') return
            errorClone[k] = !R.pathOr(false, ['quadrant', k], newWidget)
            isValid = R.pathOr(false, ['quadrant', k], newWidget) && isValid
        })
        this.setState({ error: errorClone })
        if (!isValid) return
        addWidget()
    }

    closePreview = () => {
        this.setState({ previewChart: false })
    }

    changeTitle = ({ value }) => {
        const { dashboardWizardStore } = this.props
        const { changeNewWidget } = dashboardWizardStore
        changeNewWidget(value, 'widgetTitle')
    }

    render() {
        const { dashboardWizardStore } = this.props
        const { previousStage, loading, loadingQuestions } = dashboardWizardStore
        if (loading || loadingQuestions) return <Spinner />
        return (
            <div className="quadrantSettings">
                <Tabs dashboardWizardStore={dashboardWizardStore} />
                <ModalHeader cssClass="header">
                    <div className="title">
                        New Widget
                    </div>
                    <div className="subTitle">
                        Set your quadrant default settings
                    </div>
                </ModalHeader>
                <div className="body" style={{ padding: '0 100px' }}>
                    <Input
                        name="title"
                        defaultValue="Quadrant Analysis"
                        onBlur={this.changeTitle}
                        label="Enter a title for your chart"
                        style={{ marginBottom: '15px' }}
                    />
                    {this.renderAccordion('xAxis')}
                    {this.renderAccordion('yAxis')}
                    {this.renderAccordion('zAxis')}
                </div>
                <ModalFooter>
                    <Button
                        label="Back"
                        cssClass="tertiary regular"
                        style={{ marginRight: '25px', width: '134px' }}
                        onClick={previousStage}
                    />
                    <Button
                        label="Preview"
                        cssClass="tertiary regular"
                        style={{ width: '134px', marginRight: '25px' }}
                        onClick={() => this.setState({ previewChart: true })}
                    />
                    <Button
                        label="Add Widget"
                        cssClass="primary regular"
                        style={{ width: '134px' }}
                        onClick={this.addWidget}
                    />
                    <ChartPreview
                        isOpen={this.state.previewChart}
                        close={this.closePreview}
                        dashboardWizardStore={dashboardWizardStore}
                        chart="1"
                    />
                </ModalFooter>
            </div>
        )
    }
}

export default QuadrantSettings
